// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UploadAssetResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type UploadAssetApiResponse = {
	id: number;
	url: string;
	name: string;
	size: number;
	mimeType: string;
	createdAt: string;
};

export type UploadAsset = {
	id: number;
	url: string;
	name: string;
	size: number;
	mimeType: string;
	createdAt: DateTime;
};

export function hydrateUploadAsset(data: UploadAssetApiResponse): UploadAsset {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
	};
}